import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import projectBidmanagerRoutes from 'router/routes/projects/tools/bidmanager';
import translation from 'translation';

const projectOptimisationRoutes = [
  {
    path: '/accounts/:accountId(\\d+)/projects/:projectId(\\d+)/optimization',
    component: NestedRouteComponent,
    children: [
      {
        path: 'balancing',
        name: 'projectBalancing',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Daily budget balancing')
          },
          permissions: ['READ_BALANCING']
        },
        component: () => asyncLoadView(import('pages/projects/ProjectBalancingPage')),
        props: routeArgsToInt
      },
      ...projectBidmanagerRoutes
    ]
  }
];

export default projectOptimisationRoutes;
